<div class="layout-col full">
  <span style="width: 90vw"></span>

  <app-production-code-detail class="flex" [prodCode]="prodCode" (close)="onClose($event)">
  </app-production-code-detail>
</div>
